import { render, staticRenderFns } from "./Cashback.vue?vue&type=template&id=4595244c&"
import script from "./Cashback.vue?vue&type=script&lang=ts&"
export * from "./Cashback.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports